import { createStore, applyMiddleware, Middleware, Action } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import rootReducer from './reducers';
import rootEpic from './epics';
import initialState, {RootState} from './state';

export default function configureStore() {
  const epicMiddleware = createEpicMiddleware<Action, Action, RootState, void>();

  /* Redux expects actions to be simple objects and rejects actions created using `new` operator.
   * Classes are used for action creation to use all advantages of typescript in reducers */
  const serializeActionMiddleware: Middleware = () => (next) => (action) => next({ ...action });

  const middlewareEnhancer = applyMiddleware(serializeActionMiddleware, epicMiddleware);

  const store = createStore(rootReducer, initialState, composeWithDevTools(middlewareEnhancer));

  epicMiddleware.run(rootEpic);

  return store;
}
